import { render, staticRenderFns } from "./CorpProfile.vue?vue&type=template&id=537744a2&scoped=true"
import script from "./CorpProfile.vue?vue&type=script&lang=js"
export * from "./CorpProfile.vue?vue&type=script&lang=js"
import style0 from "./CorpProfile.vue?vue&type=style&index=0&id=537744a2&prod&scoped=true&lang=scss"
import style1 from "./CorpProfile.vue?vue&type=style&index=1&id=537744a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537744a2",
  null
  
)

export default component.exports